module.exports = __webpack_public_path__ + "static/img/jigou-xinjiang-bottom.2a3bc86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-xinjiang-bottom.png
// module id = S+nL
// module chunks = 2